import '../../base/outline-container/outline-container';
import { html, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';

/**
 * The Job Posting component
 *
 * @element ghs-job-posting
 */
@customElement('ghs-job-posting')
export class GhsJobPosting extends OutlineElement {
  /**
   * The Starting Index.
   */
  @property({ attribute: 'starting-index', type: Number })
  startingIndex = 1;

  calculateTargetLevel(level: number, index: number): number {
    if (level > index) return index + 1;
    if (level < index) return index - 1;
    return index;
  }

  firstUpdated(): void {
    let currentIndex = this.startingIndex;

    super.firstUpdated();

    const styledTextNode = Array.from(this.childNodes).find(
      node => node.nodeName === 'GHS-STYLED-TEXT'
    ) as HTMLElement;

    const headerElements =
      styledTextNode
        ?.querySelector('div')
        ?.querySelectorAll('h1, h2, h3, h4, h5, h6') || [];

    headerElements.forEach(header => {
      const nodeLevel = parseInt(header.nodeName[1]);
      const targetLevel = this.calculateTargetLevel(nodeLevel, currentIndex);

      if (header.textContent) {
        const newElement = document.createElement(`h${targetLevel}`);
        newElement.innerText = header.textContent;
        header.parentNode?.replaceChild(newElement, header);
        currentIndex = targetLevel;
      }
    });
  }

  render(): TemplateResult {
    return html`<div id="job-posting"><slot></slot></div>`;
  }
}
